import { AbstractCommand } from 'src/models/command';

class CreateNewAppointmentWithTheMinimalRequiredParameters extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_CreateNewAppointmentWithTheMinimalRequiredParameters';
	readonly processId = 'random';

	public constructor(authenticatedUserId: number, startTimestamp: number, duration: number) {
		super();

		this.parameters = {
			allDay: false,
			duration: duration,
			participants: authenticatedUserId,
			startTimestamp: startTimestamp,
		};
	}
}

export { CreateNewAppointmentWithTheMinimalRequiredParameters };
